export default function Loader({ message }) {
    return (
        <div className='loader'>
            <div className="loader-area df fdc aic">
                <img style={{ width: '25%' }} src={require('../../images/wizard.gif')} />
                {message &&
                    <span className="loading-text">
                        <h3 className="text-gradient" style={{ fontSize: '1.5rem' }}>{message}</h3>
                    </span>
                }
            </div>
        </div>
    );
}